module.exports = __webpack_public_path__ + "static/media/dont3.87432c00.png";